import { render } from "./ProjectTemplateForm.vue?vue&type=template&id=8b5b54f2&scoped=true&ts=true"
import script from "./ProjectTemplateForm.vue?vue&type=script&lang=ts"
export * from "./ProjectTemplateForm.vue?vue&type=script&lang=ts"

import "./ProjectTemplateForm.vue?vue&type=style&index=0&id=8b5b54f2&scoped=true&lang=css"

import exportComponent from "/Users/matthias/Code/uniki/vergabe/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b5b54f2"]])

export default __exports__